<template>
  <div class="index3">
    <div class="box4">
      <div class="box1_top_title" @click="gotoinfo">固收</div>
      <div class="box1_top_button">
        <div class="box1_top_button_button3" :class="{ box1_top_button_button4: bxjj_navigation4 == 0 }" @click="change_top_button4(0)">可转债</div>
        <div class="box1_top_button_button3" :class="{ box1_top_button_button4: bxjj_navigation4 == 1 }" @click="change_top_button4(1)">股息率</div>
        <div class="box1_top_button_button3" :class="{ box1_top_button_button4: bxjj_navigation4 == 2 }" @click="change_top_button4(2)">新股</div>
        <div class="box1_top_button_button3" :class="{ box1_top_button_button4: bxjj_navigation4 == 3 }" @click="change_top_button4(3)">T+0 QDII</div>
        <!-- <div class="box1_top_button_button3" :class="{ box1_top_button_button4: bxjj_navigation4 == 3 }" @click="change_top_button4(3)">QDII</div> -->
        <div class="box1_top_button_button3" :class="{ box1_top_button_button4: bxjj_navigation4 == 5 }" @click="change_top_button4(5)">债券</div>
        <div class="box1_top_button_button3" :class="{ box1_top_button_button4: bxjj_navigation4 == 6 }" @click="change_top_button4(6)">现金管理</div>
        <div class="box1_top_button_button3" :class="{ box1_top_button_button4: bxjj_navigation4 == 7 }" @click="change_top_button4(7)">LOF</div>
        <div class="box1_top_button_button3" :class="{ box1_top_button_button4: bxjj_navigation4 == 8 }" @click="change_top_button4(8)">ETF</div>
        <div class="box1_top_button_button3" :class="{ box1_top_button_button4: bxjj_navigation4 == 9 }" @click="change_top_button4(9)">封闭基金</div>
        <div class="box1_top_button_button3" :class="{ box1_top_button_button4: bxjj_navigation4 == 10 }" @click="change_top_button4(10)">AH比价</div>
      </div>
      <div class="box1_top_button2" v-if="bxjj_navigation4 == 0">
        <div style="display:flex;">
          <div class="box1_top_button_button1" :class="{ box1_top_button_button2: bxjj_navigation5 == 0 }" @click="change_top_button5(0)">可转债</div>
          <div class="box1_top_button_button1" :class="{ box1_top_button_button2: bxjj_navigation5 == 1 }" @click="change_top_button5(1)">待发转债</div>
          <div class="box1_top_button_button1" :class="{ box1_top_button_button2: bxjj_navigation5 == 2 }" @click="change_top_button5(2)">已退市转债</div>
        </div>
        <div class="box1_bottom_text">
          成交额 ：<i style="color:#fd4c4c;">{{info.total_amt}}</i> &nbsp;&nbsp; 平均价格：{{info.avg_price}} &nbsp;&nbsp; 转股溢价率：{{info.avg_premium}}% &nbsp;&nbsp; 到期收益率：{{info.avg_ytm}}%
        </div>
      </div>
      <div class="box1_top_button2" v-if="bxjj_navigation4 == 1">
        <div style="display:flex;">
    
        </div>
        <div class="box1_bottom_text">
          沪深300 &nbsp; PE &nbsp; {{info2.ths_pe_ttm_index}}/PB &nbsp; {{info2.ths_pb_index}} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; A股温度 <i class="ssd" style="margin-left:5px;">{{info2.a_temperature}}℃</i>
        </div>
      </div>

      <div class="box1_top_button2" v-if="bxjj_navigation4 == 2">
        <div style="display:flex;">
          <div class="box1_top_button_button1" :class="{ box1_top_button_button2: bxjj_navigation5 == 0 }" @click="change_top_button5(0)">新股收购</div>
          <div class="box1_top_button_button1" :class="{ box1_top_button_button2: bxjj_navigation5 == 1 }" @click="change_top_button5(1)">新股上市</div>
          <div class="box1_top_button_button1" :class="{ box1_top_button_button2: bxjj_navigation5 == 2 }" @click="change_top_button5(2)">次新股</div>
          <div class="box1_top_button_button1" :class="{ box1_top_button_button2: bxjj_navigation5 == 3 }" @click="change_top_button5(3)">港股新股</div>
        </div>
        <div class="box1_bottom_text">
          
        </div>
      </div>
      <div class="box1_top_button2" v-if="bxjj_navigation4 == 3">
        <div style="display:flex;">
          <div class="box1_top_button_button1" :class="{ box1_top_button_button2: bxjj_navigation5 == 0 }" @click="change_top_button5(0)">欧美QDII</div>
          <div class="box1_top_button_button1" :class="{ box1_top_button_button2: bxjj_navigation5 == 1 }" @click="change_top_button5(1)">商品QDII</div>
          <div class="box1_top_button_button1" :class="{ box1_top_button_button2: bxjj_navigation5 == 2 }" @click="change_top_button5(2)">亚洲QDII</div>
        </div>
        <div class="box1_bottom_text">
          
        </div>
      </div>

      <div class="box1_top_button2" v-if="bxjj_navigation4 == 5">
        <div style="display:flex;">
          <div class="box1_top_button_button1" :class="{ box1_top_button_button2: bxjj_navigation5 == 0 }" @click="change_top_button5(0)">债券</div>
          <div class="box1_top_button_button1" :class="{ box1_top_button_button2: bxjj_navigation5 == 1 }" @click="change_top_button5(1)">国债</div>
          <div class="box1_top_button_button1" :class="{ box1_top_button_button2: bxjj_navigation5 == 2 }" @click="change_top_button5(2)">金融债</div>
        </div>
        <div class="box1_bottom_text">
          
        </div>
      </div>

      <div class="box1_top_button2" v-if="bxjj_navigation4 == 6">
        <div style="display:flex;">
          <div class="box1_top_button_button1" :class="{ box1_top_button_button2: bxjj_navigation5 == 0 }" @click="change_top_button5(0)">上海回购</div>
          <div class="box1_top_button_button1" :class="{ box1_top_button_button2: bxjj_navigation5 == 1 }" @click="change_top_button5(1)">深圳回购</div>
          <div class="box1_top_button_button1" :class="{ box1_top_button_button2: bxjj_navigation5 == 2 }" @click="change_top_button5(2)">交易所T+0货基</div>
          <div class="box1_top_button_button1" :class="{ box1_top_button_button2: bxjj_navigation5 == 3 }" @click="change_top_button5(3)">银行T+0理财</div>
        </div>
        <div class="box1_bottom_text">
          
        </div>
      </div>
      <div class="box1_top_button2" v-if="bxjj_navigation4 == 7">
        <div style="display:flex;">
          <div class="box1_top_button_button1" :class="{ box1_top_button_button2: bxjj_navigation5 == 0 }" @click="change_top_button5(0)">股票LOF</div>
          <div class="box1_top_button_button1" :class="{ box1_top_button_button2: bxjj_navigation5 == 1 }" @click="change_top_button5(1)">指数LOF</div>
        </div>
        <div class="box1_bottom_text">
          
        </div>
      </div>
      <div class="box1_top_button2" v-if="bxjj_navigation4 == 8">
        <div style="display:flex;">
          <div class="box1_top_button_button1" :class="{ box1_top_button_button2: bxjj_navigation5 == 0 }" @click="change_top_button5(0)">指数ETF</div>
          <div class="box1_top_button_button1" :class="{ box1_top_button_button2: bxjj_navigation5 == 1 }" @click="change_top_button5(1)">黄金ETF</div>
          <div class="box1_top_button_button1" :class="{ box1_top_button_button2: bxjj_navigation5 == 2 }" @click="change_top_button5(2)">货币ETF</div>
        </div>
        <div class="box1_bottom_text">
          
        </div>
      </div>
      <div class="box1_top_button2" v-if="bxjj_navigation4 == 9">
        <div style="display:flex;">
          <div class="box1_top_button_button1" :class="{ box1_top_button_button2: bxjj_navigation5 == 0 }" @click="change_top_button5(0)">封闭股基</div>
          <div class="box1_top_button_button1" :class="{ box1_top_button_button2: bxjj_navigation5 == 1 }" @click="change_top_button5(1)">封闭债基</div>
        </div>
        <div class="box1_bottom_text">
          
        </div>
      </div>

      <div class="box1_top_button2" v-if="bxjj_navigation4 == 10">
        <div style="display:flex;">
    
        </div>
        <div class="box1_bottom_text">
          {{info3.name}}：<i class="color_red">{{info3.latest}} {{info3.change_ratio}}%</i>
        </div>
      </div>
      <Table1 v-if="bxjj_navigation4 == 0 && bxjj_navigation5 == 0" :list="list" @getinfo='getinfo'></Table1>
      <Table12 v-if="bxjj_navigation4 == 0 && bxjj_navigation5 == 1"></Table12>
      <Table13 v-if="bxjj_navigation4 == 0 && bxjj_navigation5 == 2"></Table13>
      <Table2 v-if="bxjj_navigation4 == 1 " @getinfo2='getinfo2'></Table2>
      <Table3 v-if="bxjj_navigation4 == 2 && bxjj_navigation5 == 0"></Table3>
      <Table32 v-if="bxjj_navigation4 == 2 && bxjj_navigation5 == 1"></Table32>
      <Table33 v-if="bxjj_navigation4 == 2 && bxjj_navigation5 == 2"></Table33>
      <Table34 v-if="bxjj_navigation4 == 2 && bxjj_navigation5 == 3"></Table34>
      <Table4 v-if="bxjj_navigation4 == 3 && bxjj_navigation5 == 0"></Table4>
      <Table42 v-if="bxjj_navigation4 == 3 && bxjj_navigation5 == 1"></Table42>
      <Table43 v-if="bxjj_navigation4 == 3 && bxjj_navigation5 == 2"></Table43>
      <Table5 v-if="bxjj_navigation4 == 5 && bxjj_navigation5 == 0"></Table5>
      <Table52 v-if="bxjj_navigation4 == 5 && bxjj_navigation5 == 1"></Table52>
      <Table53 v-if="bxjj_navigation4 == 5 && bxjj_navigation5 == 2"></Table53>
      <Table6 v-if="bxjj_navigation4 == 6 &&(bxjj_navigation5 == 0)"></Table6>
      <Table64 v-if="bxjj_navigation4 == 6 &&(bxjj_navigation5 == 1)"></Table64>
      <Table62 v-if="bxjj_navigation4 == 6 &&bxjj_navigation5 == 2"></Table62>
      <Table63 v-if="bxjj_navigation4 == 6 &&bxjj_navigation5 == 3"></Table63>
      <Table7 v-if="bxjj_navigation4 == 7 &&bxjj_navigation5 == 0"></Table7>
      <Table72 v-if="bxjj_navigation4 == 7 &&bxjj_navigation5 == 1"></Table72>
      <Table8 v-if="bxjj_navigation4 == 8 && bxjj_navigation5 == 0"></Table8>
      <Table82 v-if="bxjj_navigation4 == 8 && bxjj_navigation5 == 1"></Table82>
      <Table83 v-if="bxjj_navigation4 == 8 && bxjj_navigation5 == 2"></Table83>
      <Table9 v-if="bxjj_navigation4 == 9 && bxjj_navigation5 == 0"></Table9>
      <Table92 v-if="bxjj_navigation4 == 9 && bxjj_navigation5 == 1"></Table92>
      <Table10 v-if="bxjj_navigation4 == 10" @getinfo3='getinfo3'></Table10>
      
    </div>
  </div>
</template>

<script>
import Table1 from './table/table1.vue'
import Table12 from './table/table12.vue'
import Table13 from './table/table13.vue'
import Table2 from './table/table2.vue'
import Table3 from './table/table3.vue'
import Table32 from './table/table32.vue'
import Table33 from './table/table33.vue'
import Table34 from './table/table34.vue'
import Table4 from './table/table4.vue'
import Table42 from './table/table42.vue'
import Table43 from './table/table43.vue'
import Table5 from './table/table5.vue'
import Table52 from './table/table52.vue'
import Table53 from './table/table53.vue'
import Table6 from './table/table6.vue'
import Table62 from './table/table62.vue'
import Table63 from './table/table63.vue'
import Table64 from './table/table64.vue'
import Table7 from './table/table7.vue'
import Table72 from './table/table72.vue'
import Table8 from './table/table8.vue'
import Table82 from './table/table82.vue'
import Table83 from './table/table83.vue'
import Table9 from './table/table9.vue'
import Table92 from './table/table92.vue'
import Table10 from './table/table10.vue'
import {} from '../../http/index.js'
export default {
  data(){
    return{
      bxjj_navigation4:0,
      bxjj_navigation5:0,
      data1:[{},{},{},{}],
      list:[],
      info:{},
      info2:{},
      info3:{},
    }
  },
  mounted(){
  },
  methods:{
    getinfo(e){
      this.info = e
    },
    getinfo2(e){
      this.info2 = e
    },
    getinfo3(e){
      this.info3 = e
    },
    gotoinfo(){
      this.$router.push({name:'income_Info'})
    },
    change_top_button(e){
      this.bxjj_navigation = e
    },
    change_top_button2(e){
      this.bxjj_navigation2 = e
    },
    change_top_button3(e){
      this.bxjj_navigation3 = e
    },
    change_top_button4(e){
      this.bxjj_navigation5 = 0
      this.bxjj_navigation4 = e
    },
    change_top_button5(e){
      this.bxjj_navigation5 = e
    },
  },
    components: {
    Table1,
    Table12,
    Table13,
    Table2,
    Table3,
    Table32,
    Table33,
    Table34,
    Table4,
    Table42,
    Table43,
    Table5,
    Table52,
    Table53,
    Table6,
    Table62,
    Table63,
    Table64,
    Table7,
    Table72,
    Table8,
    Table82,
    Table83,
    Table9,
    Table92,
    Table10,

  },
};
</script>

<style scoped>
i {
  font-style: normal;
}
.index3 {
  margin-bottom: 50px;
}
.box1 {
  width: calc(100% - 48px);
  padding: 35px 24px;
  border-radius: 3px;
  background-color: #fff;
}
.box1_top_title {
  font-size: 24px;
  color: #000000;
  line-height: 1;
  font-weight: bold;
  position: relative;
  padding-left: 11px;
}
.box1_top_title::before{
  content: '';
  display: block;
  width: 3px;
	height: 23px;
	background-color: #fcad2a;
	border-radius: 2px;
  position: absolute;
  left: 0;

}
.box1_top_button2{
  display: flex;
  align-content: center;
  justify-content: space-between;
  margin-bottom: 30px;
  position: relative;
  margin-top: 20px;
}
.box1_top_button{
  display: flex;
  align-content: center;
  margin-bottom: 30px;
  position: relative;
  margin-top: 20px;
}
.box1_top_button_button1 {
  padding: 6px 10px;
  text-align: center;
  font-size: 14px;
  color: #333333;
  border-radius: 6px;
  margin-left: 12px;
  background-color: #f8f8f8;
  cursor: pointer;
}
.box1_top_button_button1:nth-child(1) {
  margin-left: 0;
}
.box1_top_button_button2 {
  background-color: #fcad2a;
  color: #fff;
}
.box1_top_button_button3 {
  font-size: 16px;
  color: #666666;
  margin-left: 40px;
  cursor: pointer;
}
.box1_top_button_button3:nth-child(1) {
  margin-left: 0px;
}
.box1_top_button_button4{
  color: #fcad2a;
  position: relative;
}
.box1_top_button_button4::after{
  content: " ";
  display: block;
  width: 30px;
  height: 3px;
  background: #fcad2a;
  border-radius: 3px;
  overflow: hidden;
  margin: 0 auto;
  position: absolute;
  bottom: -9px;
  left: calc(50% - 15px)
}
.box1_content{
  display: flex;
  justify-content: space-between; 
}
.box1_content_options1{
  width: 302px;
	/* height: 127px; */
	background-color: #ffffff;
	box-shadow: 0px 4px 16px 2px 
		rgba(152, 152, 152, 0.13);
	border-radius: 3px;
  padding: 24px 23px;
  display: flex;
  flex-direction: column;
}
.box1_content_options1_top{
  font-size: 18px;
	font-weight: bold;
	color: #000000;
  line-height: 1;
}
.box1_content_options1_center{
  display: flex;
  margin-top: 20px;
  justify-content: space-between;
}
.box1_content_options1_center_left_top{
	font-size: 18px;
	color: #fd4c4c;
  line-height: 1;
}
.box1_content_options1_center_left_bottom{
	font-size: 16px;
	color: #999999;
  line-height: 1;
  margin-top: 10px;
}
.box1_content_options1_center_right_top{
  font-size: 16px;
  line-height: 1;
	color: #333333;
  text-align: right;
}
.box1_content_options1_center_right_bottom{
  display: flex;
  margin-top: 5px;
}
.box1_content_options1_center_right_bottom_left{
  width: 60px;
	height: 20px;
	border-radius: 3px;
	border: solid 1px #fcad2a;
  font-size: 12px;;
	line-height: 20px;
	color: #fcad2a;
  text-align: center;
}
.box1_content_options1_center_right_bottom_right{
  width: 60px;
	height: 20px;
	border-radius: 3px;
	border: solid 1px #539cff;
  font-size: 12px;;
	line-height: 20px;
	color: #539cff;
  text-align: center;
  margin-left: 12px;
}
.box1_content_options1_bottom{
  width: calc(100% - 24px);
	/* height: 17px; */
  line-height: 17px;
	background-image: url('../../../public/img/index2/bg1.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
	border-radius: 6px;
  margin-top: 17px;
  padding: 7px 12px;
  /* display: flex; */
}
.box1_content_options1_bottom2{
  width: calc(100% - 24px);
	/* height: 17px; */
  line-height: 17px;
	background-image: url('../../../public/img/index2/bg2.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
	border-radius: 6px;
  margin-top: 17px;
  padding: 7px 12px;
  /* display: flex; */
}
.box1_content_options1_bottom_text1{
  font-size: 12px;
  line-height: 17px;
	color: #fcad2a;
}
.box1_content_options1_bottom_text2{
  font-size: 12px;
  line-height: 17px;
	color: #333333;
  margin-left: 5px;
}
.box4 {
  width: calc(100% - 36px);
  padding: 35px 12px 35px 24px;
  border-radius: 3px;
  background-color: #fff;
  /* margin-top: 24px; */
  min-width: 1427px;
}
.box1_bottom_text{
  font-size: 14px;
  line-height: 31px;
	color: #333333;
  margin-right: 15px;
}



.color_red{
  color: #fd4c4c;
}
.color_green{
  color:#41b357;
}
.ssd{
  background-color: #539cff;
  font-size: 10px;
  height: 13px;
  line-height: 13px;
  border-radius: 3px;
  color: #fefefe;
  padding: 0 5px;
}

.fontSize16{
  font-size: 16px;
}
.BackColorGreen{
  background-color: #41b357;
}
.BackColorBlue{
  background-color: #4372ba;
}
</style>